import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { IChangeBookmarkFolderParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useChangeBookmarkFolder = (
  options?: UseMutationOptions<any, any, IChangeBookmarkFolderParams>
) => {
  const { bookmarksApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: IChangeBookmarkFolderParams) =>
      bookmarksApiService.createCancellableRequest((cancelToken) =>
        bookmarksApiService.changeBookmarkFolder(payload, cancelToken)
      ),
    [bookmarksApiService]
  );

  const mutation = useMutation<any, any, IChangeBookmarkFolderParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.BOOKMARK_FOLDER_ALL);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
